export function scrollTo(element, to, duration) {
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop == to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
}

export { scrollTo };

export function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

export { sortByKey };

export function sortQualifications( array ) {

    var sortedQualifications = [];

    function getQualification(x) {return x.qualification;}
    var qualificationTypes = array.map(getQualification).sort();

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    qualificationTypes = qualificationTypes.filter( onlyUnique );

    // loop over JSON response to populate data structure
    for (var x = 0; x < qualificationTypes.length; x++ ) {

        sortedQualifications.push( {
            qualification: qualificationTypes[x],
            subjects: []
        });

    }

    function sortByThenBy(array, by, thenBy ){
        return array.sort(function (a,b) {
            var by1 = a[by].toLowerCase();
            var by2 = b[by].toLowerCase();

            var thenBy1 = a[thenBy].toLowerCase();
            var thenBy2 = b[thenBy].toLowerCase();

            if ( by1 < by2) return -1;
            if ( by1 > by2) return 1;
            if ( thenBy1 < thenBy2) return -1;
            if ( thenBy1 > thenBy2) return 1;
            return 0;
        });
    }

    var sortedBySCQF = sortByThenBy( array, 'scqf', 'subject' );

    // loop over JSON response to populate data structure
    for (var y = 0; y < sortedBySCQF.length; y++ ) {

        var qualification = sortedBySCQF[y].qualification;
        var qualPos = qualificationTypes.indexOf( qualification );

        sortedQualifications[ qualPos ].subjects.push({
            "qualification" : sortedBySCQF[y].qualification,
            "level" : sortedBySCQF[y].level,
            "scqf" : sortedBySCQF[y].scqf,
            "qcf" : sortedBySCQF[y].qcf,
            "title" : sortedBySCQF[y].subject,
            "url" : sortedBySCQF[y].content_id
        });

    }

    return sortedQualifications;

}

export { sortQualifications }

export function countQualifications( array ) {

    var count = 0;

    for(var x = 0; x < array.length; x++) {

        count = count + array[x].subjects.length;

    }

    return count;

}

export { countQualifications }


/** WEBPACK FOOTER **
 ** ./app/functions.js
 **/